import React from 'react'
import './UnderlineLink.scss'

const UnderlineLink = ({ children, className = '' }) => (
  <span className={`underline-link ${className}`.trim()}>
    {children}
  </span>
)

export default UnderlineLink
